'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookie = new _universalCookie2.default();

var Auth = function (_Component) {
    (0, _inherits3.default)(Auth, _Component);

    function Auth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Auth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Auth.__proto__ || (0, _getPrototypeOf2.default)(Auth)).call.apply(_ref, [this].concat(args))), _this), _this.getExp = function () {
            var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var splitToken = token.split('.');
            if (splitToken.length < 2) {
                console.warn('Failed to decode JWT expiration');
                return;
            }
            try {
                if (!atob(splitToken[1])) {
                    return;
                }
                var payload = JSON.parse(atob(splitToken[1]));
                return new Date(payload.exp * 1000);
            } catch (e) {
                console.warn('Failed to decode JWT expiration', e);
                return new Date(0);
            }
        }, _this.setAuthCookie = function (authToken, expires) {
            cookie.set('bidder-auth', authToken, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
        }, _this.setMainhostCookies = function (mainhostLogin, expires) {
            cookie.set('5Xq_name', mainhostLogin.authName, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
            cookie.set('5Xq_nuid', mainhostLogin.authNuid, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
            cookie.set('5Xq_nverify', mainhostLogin.authVerify, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
        }, _this.unsetCookies = function () {
            cookie.remove('auctioneer-auth', { domain: '.liveauctioneers.com', path: '/' });
            cookie.remove('bidder-auth', { domain: '.liveauctioneers.com', path: '/' });
            cookie.remove('5Xq_name', { domain: '.liveauctioneers.com', path: '/' });
            cookie.remove('5Xq_nuid', { domain: '.liveauctioneers.com', path: '/' });
            cookie.remove('5Xq_nverify', { domain: '.liveauctioneers.com', path: '/' });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Auth, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.userData && !prevProps.userData) {
                this.props.recordAnalyticsForIdentify({ bidder: this.props.userData });
            }

            var _props = this.props,
                nextAuthToken = _props.authToken,
                nextMainhostLogin = _props.mainhostLogin,
                nextUserLoggedIn = _props.userLoggedIn;


            if (!prevProps.authToken && nextAuthToken || !!nextAuthToken && prevProps.authToken !== nextAuthToken) {
                var expires = this.getExp(nextAuthToken);

                this.setAuthCookie(nextAuthToken, expires);
                if (nextMainhostLogin.authVerify) {
                    this.setMainhostCookies(nextMainhostLogin, expires);
                }
            }

            if (prevProps.userLoggedIn && !nextUserLoggedIn) {
                this.unsetCookies();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Auth;
}(_react.Component);

exports.default = Auth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/Auth.js
// module id = WGE/
// module chunks = 60